<template>
  <section
    class="d-flex align-center direction-column"
    :class="{ 'direction-md-row': !isVertical }"
  >
    <slot name="default" />
  </section>
</template>

<script>
export default {
  name: 'CongratModal',
  props: {
    isVertical: { type: Boolean },
  },
}
</script>
